import { stringifyUrl } from '../baseQuery';
export var getCampaignMatchesStatsEndpoint = function(builder) {
    return builder.query({
        query: function(param) {
            var id = param.id, query = param.query;
            return stringifyUrl("/campaigns/".concat(id, "/matches_stats"), query);
        },
        keepUnusedDataFor: 15
    });
};
